<script>
  import ActionReportMixin from './ActionReportMixin.vue'

  export default {
    name: 'RbvHotelRfpBidManagerChangeTravelDestinationActionReport',
    mixins: [ ActionReportMixin ],
    data () {
      return {
        messages: {
          'OK': 'Success!',
          'NOT_FOUND': `Bid was not found`,
          'ERROR': 'Travel Destination not changed due to unknown error'
        }
      }
    },
    computed: {
      title () { return this.items.length === 1 ? 'Travel Destination not changed!' : 'There were errors...' },
      message () {
        return this.items.length === 1
          ? 'We were not able to change travel destination because of the reason listed below:'
          : `${this.items.length - this.failures} of ${this.items.length} successfully updated.<br /> We were not able to update others because of the reasons listed below:`
      }
    }
  }
</script>
